import apiNewsletter from '../api/newsletter'
import { showAlertError, showAlertSuccess} from './alertlj'


export const actionTypes = {
	SUSCRIBE_NEWSLETTER_SENDED: 'newsletter/SUSCRIBE_NEWSLETTER_SENDED',
	RECEIVE_NEWSLETTER_RESPONSE: 'newsletter/SUSCRIBE_NEWSLETTER_RESPONSE',
	RECEIVE_NEWSLETTER_ERROR: 'newsletter/SUSCRIBE_NEWSLETTER_ERROR',
	CLEAR_NEWSLETTER_STATE: 'newsletter/CLEAR_NEWSLETTER_STATE'
}

export const suscribeNewsletter = (email) => {
	return(dispatch, getstore) => {

		dispatch(suscribeNewsletterSended())
		apiNewsletter.suscribe(email)
			.then((data) => {
				dispatch(receiveNewsletterResponse())
				dispatch(clearNewsletterState())
				dispatch(showAlertSuccess('Tu email fue suscripto a nuestra lista de emails.'))
			}, (data) => {
				dispatch(showAlertError(data.mensaje))
			})
	}
}


export const suscribeNewsletterSended = () => {
	return {
		type: actionTypes.SUSCRIBE_NEWSLETTER_SENDED,
	}
}

function receiveNewsletterResponse(){
	return {
		type: actionTypes.RECEIVE_NEWSLETTER_RESPONSE,
	}
}

export const clearNewsletterState = () => {
	return {
		type: actionTypes.CLEAR_NEWSLETTER_STATE
	}
}



// WEBPACK FOOTER //
// ./src/actions/newsletterWidget.js